'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = RestrictedLengthText;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('../styles/RestrictedLengthText.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RestrictedLengthText(_ref) {
  var text = _ref.text,
      limit = _ref.limit;

  var textUpToLimit = text.slice(0, limit);
  var textAfterLimit = text.slice(limit);

  return _react2.default.createElement(
    'span',
    { className: 'cp-restricted-length-text' },
    textUpToLimit,
    _react2.default.createElement(
      'span',
      { className: 'text-over-limit' },
      textAfterLimit
    )
  );
}

RestrictedLengthText.propTypes = {
  text: _react.PropTypes.string,
  limit: _react.PropTypes.number
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/restricted-length-text/components/RestrictedLengthText.component.js
// module id = 1332
// module chunks = 0